export default __webpack_public_path__ + "static/media/pic1.d7f3bf9c.png";